<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
    id: Number,
    image: String,
    name: String,
    creation_time: String,
    views: Number,
    text: String
})

let img_url = computed(()=>{
    if (props.image === null){
        window.document.location.origin+ '/img/background.jpeg'
    }
    return window.document.location.origin+'/'+props.image
})

</script>

<template>
    <router-link
        :to="`/about/our_losses/${props.id}`"
        class="our-losses-card"
    >
        <div
            class="our-losses-card-image"
            :style="{
                backgroundImage: `url('${img_url}')`,
                backgroundSize: 'contain'
            }"
        ></div>
        <div class="our-losses-card-container">
            <div class="our-losses-card-text">{{ props.name }}</div>
            <div class="our-losses-card-footer">
                <div class="our-losses-card-footer-info">
                    <img
                        src="/svg/calendar_date.svg"
                        alt="Календарь"
                    />
                    {{
                        new Date(props.creation_time).toLocaleDateString(
                            'ru-RU',
                            {
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            }
                        )
                    }}
                </div>
                <div class="our-losses-card-footer-info">
                    <img
                        src="/svg/views.svg"
                        alt="Глаз"
                    />
                    {{ props.views }}
                </div>
            </div>
        </div>
    </router-link>
</template>

<style lang="scss" scoped>
.our-losses-card {
    display: block;
    height: 400px;
    background: #fff;
    box-shadow: 1px 1px 50px 10px #2632380d;
    border-radius: 5px;
    text-decoration: none;
    color: unset;

    &:hover {
        background-color: rgb(240, 240, 240);
        transition: background-color 0.2s;
    }
}

.our-losses-card-image {
    width: 100%;
    height: 270px;
    border-radius: 5px 5px 0 0;
    background-size: cover;
    background-position: center;
}

.our-losses-card-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 10px 25px 10px;
    height: 130px;
}

.our-losses-card-text {
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    text-align: left;
    color: #00388D;
    margin-top: 10px;
}

.our-losses-card-footer {
    color: #a2a2a2;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    gap: 10px;
}

.our-losses-card-footer-info {
    display: flex;
    align-items: center;
    gap: 5px;
}
</style>
